module.exports = __webpack_public_path__ + "img/Number=59.4a36550f.png";